import { render, staticRenderFns } from "./CaseViewerChildren.vue?vue&type=template&id=adda7b66&scoped=true&"
import script from "./CaseViewerChildren.vue?vue&type=script&lang=js&"
export * from "./CaseViewerChildren.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerChildren.vue?vue&type=style&index=0&id=adda7b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda7b66",
  null
  
)

export default component.exports